/** @jsx isolateComponent */

import { useState } from 'react';
import { css } from '@emotion/core';

import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';

import { Img } from '../../display/Img';
import { ImgProps } from '../../display/Img';
import { SkeletonBlock } from '../../display/SkeletonLoader';

type LoadableImgProps = ImgProps;

const Styles = labelStyles('LoadableImg', {
  placeholder: css`
    position: absolute;
    left: -9999;
  `,
});

const ImgSkeletonLoader = (props: LoadableImgProps) => {
  const [ratioWidth, ratioHeight] = (props.aspectRatio || '')
    .split(':')
    .map((part: string) => {
      return part && parseFloat(part);
    });
  const aspectRatio =
    ratioWidth && ratioHeight ? ratioWidth / ratioHeight : undefined;
  return (
    <SkeletonBlock
      aspectRatio={aspectRatio}
      height={props.height}
      width={props.width === null ? undefined : props.width}
    />
  );
};

/**
 * Displays a block level loading placeholder while Img is loading.
 *
 * Accepts all props from `Img` and passes them through.
 */
export const LoadableImg = (props: LoadableImgProps) => {
  const [loaded, setLoaded] = useState(false);

  const onLoad = (event: any) => {
    if (typeof props.onLoad === 'function') {
      props.onLoad(event);
    }
    setLoaded(true);
  };

  return (
    <div>
      <div css={loaded ? undefined : Styles.placeholder}>
        <Img {...props} onLoad={onLoad} />
      </div>
      {!loaded && <ImgSkeletonLoader {...props} />}
    </div>
  );
};
